import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { HttpService } from '../../../../services/common/http/common.http.service';
import { PermissionService } from '../../../../services/permission.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppExportBase64 } from '../../../../services/exportBase64/exportBase64.service';
import { HubConnectionService } from '../../../../services/ping/hubConnection.service';
import moment from 'moment';
import { formatCpf } from '../../../../utils/utility-functions';

@Component({
  selector: 'app-listagem-ajustes-layout',
  templateUrl: './listagem-ajustes-layout.component.html',
  styleUrls: ['./listagem-ajustes-layout.component.scss'],
})
export class ListagemAjustesLayoutComponent implements OnInit, OnDestroy {
  permission: number = 2;
  tableData: any[] | Array<any> = [];
  pessoaData: any = {};
  visibleHorariosApontados: boolean = false;
  visibleExtracaoRelatorio: boolean = false;
  expandirCardsMobile: boolean = false;
  loader: boolean = false;

  pesquisaParams = {
    TxPesquisar: '',
    DtInicio: '',
    DtFim: '',
    Pagina: 0,
    TamanhoPagina: 8,
    MaxPages: 1,
  };

  hubName = 'pingHubPointing';
  hubReceiveName = 'pingHubPointingReceive';

  constructor(
    private httpService: HttpService,
    private permissionService: PermissionService,
    private router: Router,
    private toast: ToastrService,
    private exportBase64Service: AppExportBase64,
    private hubConnectionService: HubConnectionService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    this.hubConnectionService.stopConnection();
  }

  ngOnInit() {
    this.permission = this.permissionService.getPermission();
    this.getAjustes();
    this.changeDetectorRef.detectChanges();
    this.hubConnectionService.configureHub(this.hubName, this.hubReceiveName);
    this.hubConnectionService
      .getMessages()
      .subscribe((msg) => this.toast.info(msg.message));
  }

  tableColumns = [
    {
      header: 'Nome e CPF',
      key: '',
      keyArray: ['nome', 'cpf'],
      type: 'textArray',
    },
    { header: 'Tipo de Contratação', key: 'tipoContratacao', type: 'text' },
    { header: 'Responsável pelo Ajuste', key: 'realizadoPor', type: 'text' },
    { header: 'Data do Ajuste', key: 'data', type: 'text' },
    {
      header: 'Ações',
      key: 'acoes',
      type: 'buttons',
      buttons: [
        {
          img: 'assets/images/edit.svg',
          label: 'Editar',
          action: (item: any) => this.navigateAjuste(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  rowsMobile = [
    { header: 'Nome', key: 'nome', type: 'text', default: true },
    {
      header: 'CPF',
      key: 'cpf',
      type: 'text',
      default: true,
      style: 'blue',
    },
    { header: 'Responsável pelo Ajuste', key: 'realizadoPor', type: 'text' },
    { header: 'Data do Ajuste', key: 'data', type: 'text' },

    {
      header: 'Ações',
      key: 'acoes',
      type: 'buttons',
      buttons: [
        {
          img: 'assets/images/edit.svg',
          label: 'Editar',
          action: (item: any) => this.verHorarios(item),
          condition: (item: any) => true,
        },
      ],
    },
  ];

  navigateAdicionarAjuste() {
    this.router.navigate(['encarregado/ajuste-apontamento']);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.getAjustes();
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getHours(date: Date) {
    if (date !== null) {
      return moment(date).format('HH:mm');
    }
    return '--';
  }

  getDate(date: Date) {
    if (date !== null) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '--';
  }

  getAjustes() {
    this.loader = true;
    const params = this.pesquisaParams;

    this.httpService.useGet('AjustesByFilters', params).subscribe({
      next: (response: any) => {
        this.loader = false;
        this.tableData = response.DataSet.map((item: any) => {
          return {
            id: item.ApontamentoId ?? 0,
            nome: item.TxNome,
            cpf: formatCpf(item.TxCPF),
            tipoContratacao: item.TipoPessoaId == 1 ? 'CLT' : 'Reeducando',
            realizadoPor: item.NmFuncionario,
            data: this.getDate(item.DtCriacao),
            idPessoa: item.IdPessoa,
          };
        });
        this.pesquisaParams.MaxPages =
          Math.ceil(response.Total / this.pesquisaParams.TamanhoPagina) || 1;
      },
      error: (_error: any) => {
        this.loader = false;
        this.toast.error(
          'Não foi possível buscar apontamentos. Tente novamente!'
        );
      },
    });
  }

  extracaoAdvertencia() {
    this.loader = true;
    const body = {
      TxPesquisar: this.pesquisaParams.TxPesquisar.toLowerCase(),
    };

    this.httpService.usePostFilter('AdvertenciaXslx', body).subscribe({
      next: (response: any) => {
        this.exportBase64Service.downloadExcel(
          response.DataSet,
          'relatorio-advertencia'
        );
        this.loader = false;
      },
      error: (_error) => {
        this.toast.error('Ocorreu um erro ao exportar excel. Tente novamente!');
        this.loader = false;
      },
    });
  }

  apontamentoDiario() {
    this.loader = true;
    const body = {
      TxPesquisar: this.pesquisaParams.TxPesquisar.toLowerCase(),
    };

    this.httpService.usePostFilter('ApontamentoHoraXlsx', body).subscribe({
      next: (response: any) => {
        this.exportBase64Service.downloadExcel(
          response.DataSet,
          'apontamento-hora'
        );
        this.loader = false;
      },
      error: (_error) => {
        this.toast.error('Ocorreu um erro ao exportar excel. Tente novamente!');
        this.loader = false;
      },
    });
  }

  extracaoRelatorio() {
    this.visibleExtracaoRelatorio = !this.visibleExtracaoRelatorio;
  }

  verHorarios(item?: any) {
    this.pessoaData = item;

    this.visibleHorariosApontados = !this.visibleHorariosApontados;
  }

  timer: ReturnType<typeof setTimeout> | null = null;
  onChangeSearch() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.getAjustes();
    }, 800);
  }

  navigateAjuste(item: any) {
    this.router.navigate(['encarregado/ajuste-apontamento'], {
      queryParams: {
        IdPessoa: item.idPessoa,
        IdApontamento: item.id,
      },
    });
  }
}
